import { create } from "zustand";

const storedTheme = typeof window !== "undefined" ? window.localStorage.getItem("aviando-theme") : null;

export const useUiStore = create((set, get) => ({
  theme: storedTheme || "light",
  captureOpen: false,
  sidebarCollapsed: false,
  setTheme: (theme) => {
    window.localStorage.setItem("aviando-theme", theme);
    set({ theme });
  },
  toggleTheme: () => get().setTheme(get().theme === "dark" ? "light" : "dark"),
  openCapture: () => set({ captureOpen: true }),
  closeCapture: () => set({ captureOpen: false }),
  toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
}));
